module.exports = __webpack_public_path__ + "img/47.d79e28c0.jpg";